import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const WinnerPrediction = ({ teams, selectedWinner, onSelect, disabled, error }) => {
  return (
    <div className="space-y-3 md:space-y-4">
      {teams?.map((team) => (
        <button
          key={team?.id}
          onClick={() => !disabled && onSelect(team?.id)}
          disabled={disabled}
          className={`w-full flex items-center gap-4 p-4 md:p-5 rounded-lg border-2 transition-all duration-250 ${
            selectedWinner === team?.id
              ? 'border-primary bg-primary/5'
              : error
              ? 'border-destructive hover:border-destructive/70 hover:bg-muted/50' :'border-border hover:border-primary/50 hover:bg-muted/50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden bg-muted flex-shrink-0">
            <Image 
              src={team?.flag} 
              alt={team?.flagAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 text-left">
            <h4 className="text-base md:text-lg font-semibold text-foreground">{team?.name}</h4>
            <p className="text-xs md:text-sm text-muted-foreground">{team?.shortName}</p>
          </div>
          <div className={`w-6 h-6 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
            selectedWinner === team?.id
              ? 'border-primary bg-primary' :'border-muted-foreground'
          }`}>
            {selectedWinner === team?.id && (
              <Icon name="Check" size={16} color="#FFFFFF" />
            )}
          </div>
        </button>
      ))}
      {error && (
        <p className="flex items-center gap-1.5 text-xs text-destructive mt-1">
          <Icon name="AlertCircle" size={13} className="text-destructive flex-shrink-0" />
          {error}
        </p>
      )}
    </div>
  );
};

export default WinnerPrediction;